module.exports = __webpack_public_path__ + "img/img-back.5030c7ff.png";